import router from './router';
import template from './anchor.tpl';
import './anchor.css';

const Anchor = DomClass(template, function Anchor() {
	const _t = this;

	this.__dom.href.onclick = function(evt) {
		var e = evt || window.event;
		e.preventDefault();
		_t.open();
		return false;
	};

	this.open = function() {
		router.navigate(this.href);
	};

	if (this.parameters) {
		this.body = this.parameters;
	}
});

export default Anchor;